{
    "coordinates": [
        50.613162087338594,
        -2.134961684703171
    ],
    "tooltip": "Kimmeridge Clay",
    "title": "Kimmeridge Clay",
    "country": "England (UK)",
    "period": "Jurassic",
    "alt": "TODO"
}